import { createI18n } from 'vue-i18n'
import sl from '@/../lang/sl-SI.json'

export default createI18n({
    warnHtmlMessage: false,
    numberFormats: {
        sl: {
            currency: {
                style: 'currency',
                currency: 'eur',
                notation: 'standard'
            }
        },
        EUR: {
            currency: {
                style: 'currency',
                currency: 'eur',
                notation: 'standard'
            }
        },
        en: {
            currency: {
                style: 'currency',
                currency: 'eur',
                notation: 'standard'
            }
        }
    },
    datetimeFormats: {
        sl: {
            short: {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            },
            long: {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                weekday: 'short'
            },
            full: {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                weekday: 'long'
            }
        }
    },
    legacy: false,
    locale: document.documentElement.lang,
    pluralRules: {
        sl: customRule
    },
    messages: {
        sl: sl // ← THIS WAS WRONG BEFORE
    }
})

function customRule(choice) {
    return choice < 5 ? choice : 5
}
